import React, { useEffect, useState } from 'react'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import Championships from './Championships'
import Description from './Description'
import Learning from './Learning'
import Requirements from './Requirements'
import BackLink from '@/components/BackLink'
import Container from '@/components/Container'
import { usePage } from '@/hooks'
import { api } from '@/api'
import { IGame } from '@/interfaces/Game'

const GameDetail = (): React.ReactElement => {
  const [game, setGame] = useState<IGame | undefined>()
  const [playVideo, setPlayVideo] = useState('')
  const page = usePage()
  const object = page.init_state.object
  const global = page.init_state.global

  useEffect(() => {
    api
      .getGame(object.id)
      .then(data => {
        setGame(data)
      })
      .catch(error => {
        console.error(error)
      })
  }, [object.id])

  return (
    <>
      <Container>
        <BackLink title='Все игры' href={global.config.games} />
      </Container>
      <Description
        title={object.title}
        description={game?.detail_text ?? ''}
        isNew={game?.property_new_value === '1'}
        video={game?.property_trailer_value?.[0]}
        screenshots={game?.property_images_value ?? []}
        detailPicture={game?.detail_picture?.[0]}
        preview={game?.property_preview_trailer_value?.[0] ?? ''}
        systems={game?.system_requirements ?? []}
        playVideo={playVideo}
        setPlayVideo={setPlayVideo}
      />
      <Requirements info={game?.system_requirements ?? []} />
      {game !== undefined
        ? (
          <Learning
            questions={game.questions}
            video={game.property_edu_video_value?.[0] ?? ''}
            title={game.property_title_edu_video_value ?? ''}
            preview={game.property_preview_edu_video_value?.[0] ?? ''}
            playVideo={playVideo}
            setPlayVideo={setPlayVideo}
          />
          )
        : null}
      {game != null
        ? (
          <FetcherList
            isScrollTop={false}
            isHistoryPush={false}
            initFilter={{
              version: game.property_jeka_version_value,
              page_size: 2
            }}
            api={api.getChampionships}
          >
            {({ results }) => {
              return <Championships championships={results} />
            }}
          </FetcherList>
          )
        : null}
    </>
  )
}

export default GameDetail
